import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6e1730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ef-header" }
const _hoisted_2 = { class: "ef-header__title" }
const _hoisted_3 = { class: "ef-header__actions" }
const _hoisted_4 = ["onClick"]

import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  props: {
  title: { type: String, default: '' },
  icone: { type: String, default: '' },
  actions: { type: Array, default: [] },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass(__props.icone)
      }, null, 2),
      _createElementVNode("div", null, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_Popper, {
            arrow: true,
            hover: true,
            content: action.text
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(['clickable', action.icon]),
                onClick: ($event: any) => (_ctx.$emit(`${action.action}`))
              }, null, 10, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["content"])
        ]))
      }), 128))
    ])
  ]))
}
}

})